import Service from "../../Services";

const MembershipRate = {
  namespaced : true,
  state : {
    form : {
      id : '',
      branch_id : '',
      detail_en : '',
      detail_th : '',
      one_day_pass : '',
      annual_fee : '',
      is_publish : true,
    },
  },
  mutations : {
    GET_FORM_MEMBERSHIP_RATE : (state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA : (state)=>{
      state.form = {
        id : '',
        branch_id : '',
        detail_en : '',
        detail_th : '',
        one_day_pass : '',
        annual_fee : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getMembershipRate({commit},page){
      return Service.MembershipRateAPI.getMembershipRate(page);
    },
    showMembershipRate({commit},id){
      return Service.MembershipRateAPI.showMembershipRate(id);
    },
    saveMembershipRate({commit},{id,data}){
      if(id){
        return Service.MembershipRateAPI.updateMembershipRate(id,data);
      }else{
        return Service.MembershipRateAPI.createMembershipRate(data);
      }
    },
    deleteMembershipRate({commit},id){
      return Service.MembershipRateAPI.deleteMembershipRate(id);
    },
    setFormMembershipRate({commit},res){
      commit('GET_FORM_MEMBERSHIP_RATE',res);
    },
    clearFormDataMembershipRate({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default MembershipRate
